import { parseDate } from "./parseDate";
import { DateFormat } from "./types";

export const formatDate = (date: Date, timeZone: string | undefined, dateFormat = DateFormat.WeekMonthDay) =>
  parseDate(date, dateFormat, timeZone);
